import { Box } from '@mui/material';
import { IconButton } from '@sweep-io/sweep-design';
import { Close } from '@sweep-io/sweep-design/dist/icons';
import { useEffect } from 'react';
import { MetadataMappingPrompt } from './MetadataMappingPrompt';
import { usePageHelpers } from '../usePageHelpers';
import { useMetadataMapping } from '../useMetadataMapping';
import { MetadataMappingLoader } from './MetadataMappingLoader';

export const MetadataMappingZeroState = ({ onClose }: { onClose?: () => void }) => {
  const { funnelMapId } = usePageHelpers();

  const { status, error, message, isLoading, sendMessage, complete } = useMetadataMapping(
    funnelMapId || '',
  );

  useEffect(() => {
    if (status === 'completedFetchingData') {
      complete();
    }
  }, [status, complete]);

  return (
    <Box
      sx={{
        width: '600px',
        backgroundColor: 'transparent',
        boxSizing: 'border-box',
        padding: 0,
        position: 'relative',
      }}
    >
      {onClose && (
        <Box
          sx={{
            position: 'absolute',
            top: '4px',
            right: 0,
            zIndex: 2,
          }}
        >
          <IconButton variant="system" onClick={onClose} size="tiny">
            <Close />
          </IconButton>
        </Box>
      )}
      <MetadataMappingPrompt
        onSendMessage={sendMessage}
        error={error}
        loading={isLoading}
        message={message || null}
      />
      {isLoading && <MetadataMappingLoader overlayOpacity={1} />}
    </Box>
  );
};
